
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wszystkie-kierunki",
      function () {
        return require("private-next-pages/wszystkie-kierunki.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wszystkie-kierunki"])
      });
    }
  